import { useState } from 'hooks'
import $ from 'jquery'

import { editor } from '../../constant'

import { getQuestionsComponents } from './selector'

type State = {
	periodSelect?: HTMLSelectElement
}

export const Questions = (() => {
	const { state, setState } = useState<State>()

	const initPeriodsSelect = () => {
		const { periodSelect } = state

		if (!periodSelect) {
			return
		}
		periodSelect.addEventListener('change', () => {
			const selectedOptions = []
			const { options } = periodSelect

			for (let i = 0; i < options.length; i++) {
				if (options[i].selected) {
					selectedOptions.push(options[i].value)
				}
			}

			// @ts-ignore
			$.nette.ajax({
				type: 'POST',
				url: periodSelect.getAttribute(editor.editorComponentChangeHandler),
				data: {
					period_select: selectedOptions,
				},
			})
		})
	}

	const init = () => {
		setState({ ...getQuestionsComponents() })
		initPeriodsSelect()
	}

	return {
		init,
	}
})()
